module.exports = __webpack_public_path__ + "img/r-michelle-tsang-500721-unsplash-min.052e4506.jpg";